// extracted by mini-css-extract-plugin
module.exports = {"landing":"Planeta_landing__1OdBy","planetas":"Planeta_planetas__2gQYY","imgPlanet":"Planeta_imgPlanet__2cWRa"};